import * as AuthorizationWebService from '../webServices/AuthorizationWebService.js';
import { Unauthorized, Forbidden } from '../exceptions';
import {
  DefaultMenu,
  MenuItem
} from '../objects/FeaturesSetting.js';
import store from '../store';

export async function GetCompaniesAsync() {
  const { accessToken } = store.getters;
  if ((accessToken || '') !== '') {
    const companies = await AuthorizationWebService.GetCompaniesAsync(accessToken) || {};
    return companies;
  }
  return [];
}

export async function GetFeaturesAsync() {
  const { accessToken, company } = store.getters;
  if ((accessToken || '') !== '' && (company || '') !== '') {
    const features = await AuthorizationWebService.GetFeaturesAsync(accessToken, company) || {};
    return features;
  }
  return [];
}

// 取得操作權限
export async function GetPermissionsAsync(featureId) {
  const { accessToken, company } = store.getters;

  try {
    return await AuthorizationWebService.GetPermissionsAsync(accessToken, company, featureId);
  } catch (e) {
    return [];
  }
}

export async function LoadEnabledFeaturesAsync() {
  const features = await GetFeaturesAsync();
  const enabledFeatures = MenuItem.GetEnabledMenuItem(features, DefaultMenu);
  store.commit('setFeatures', enabledFeatures);
}

export async function VerifyAuthorizationAsync(featureId) {
  store.dispatch('loadCompany');
  const { accessToken, company } = store.getters;

  try {
    await AuthorizationWebService.VerifyAsync(accessToken, company, featureId);
    return true;
  } catch (e) {
    if (e instanceof Unauthorized || e instanceof Forbidden) {
      return false;
    }
  }
}
